import React from 'react';
import { connect } from "react-redux";
import { setView, alert } from '../actions';
import '../styles/elements/main-panel.scss';
import {VoiceContainer} from "./Voice";
import TranslationService from "../app/services/TranslationService";
import {LanguageComponent} from "./LanguageComponent";
import axios from "axios";
import {config} from "../app/config";
import {Clipboard} from "./Clipboard";

class MainPanel extends React.Component {
    /**
     * @param props
     */
    constructor(props) {
        super(props);

        this.state = {
            menu: '',
            notifications: '',
            clipboard: false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.view !== this.props.view) {
            let menu = this.state.menu;
            if (menu === 'imd-opened') {
                menu = 'imd-closed';
            }

            let notifications = this.state.notifications;
            if (notifications === 'imd-opened') {
                notifications = 'imd-closed';
            }

            this.setState({menu: menu, notifications: notifications});

            // protect animation glitch
            let that = this;
            setTimeout(() => {
                that.setState({menu: '', notifications: ''});
            }, 1000);
        }
    }

    switchMenuVisibility = (menuName) => {
        if (menuName === 'menu') {
            if (this.state.menu !== 'imd-opened') {
                this.setState({menu: 'imd-opened'});
            } else {
                this.setState({menu: 'imd-closed'});
            }

            if (this.state.notifications === 'imd-opened') {
                this.setState({notifications: 'imd-closed'});
            }
        }

        if (menuName === 'notifications') {
            if (this.state.notifications !== 'imd-opened') {
                this.setState({notifications: 'imd-opened'});
            } else {
                this.setState({notifications: 'imd-closed'});
            }

            if (this.state.menu === 'imd-opened') {
                this.setState({menu: 'imd-closed'});
            }
        }
    }

    open = (screenName) => {
        this.props.setView(screenName);
        this.setState({menu: 'imd-closed', notifications: false});
    }

    setNotificationAsRead = (id) => {
        let that = this;
        axios.patch(config.apiAddress + '/notifications/set-as-read/' + id)
            .then(function (response) {
                that.props.reloadNotificaions();
            }).catch(function(error) {
        });
    }

    countNotifications = () => {
        return this.props.notifications.new.length + this.props.notifications.unread.length;
    }

    authorizeIMid = () => {
        let that = this;
        axios.post(config.apiAddress + '/app/imid/authorize')
            .then(function (response) {
                that.props.alert(TranslationService.trans(that.props.language, 'menu.imid.message'));
            }).catch(function(error) {
            console.log(error)
        });

        this.setState({menu: false, notifications: false});
    }

    /**
     * @returns {XML}
     */
    render() {
        let notificationsCounter = this.countNotifications();

        return (
            <div id="main-panel" className={"imd-bg-transparent-default"} style={{display: (this.props.email !== null ? 'block' : 'none')}}>
                <VoiceContainer />
                <Clipboard
                    open={this.state.clipboard}
                    close={() => this.setState({clipboard: false})}
                />

                <button
                    type="button"
                    className={'imd-nav-button' + (this.state.menu !== 'imd-opened' ? '' : ' imd-opened')}
                    onClick={() => this.switchMenuVisibility('menu')}
                >
                    <span className="imd-bar"></span>
                    <span className="imd-bar"></span>
                    <span className="imd-bar"></span>
                </button>

                <button
                    type="button"
                    className={"notification-button"}
                    onClick={() => this.switchMenuVisibility('notifications')}
                >
                    <span className={"imd-icon imd-icon-bell imd-text-contrast"} />
                    <span className={"counter"} style={{display: notificationsCounter === 0 ? 'none' : 'inline-block'}}>
                        {notificationsCounter > 9 ?
                            TranslationService.transNumbers(this.props.language, '9') + '+' :
                            TranslationService.transNumbers(this.props.language, notificationsCounter)
                        }
                    </span>
                </button>

                <div className={'imd-sidebar menu ' + this.state.menu}>
                    <div className={"imd-sidebar-content imd-bg-blur-real-black"}>
                        <ul style={{paddingTop: '30px'}}>
                            <li className={'imd-text-contrast' + (this.props.view === null || this.props.view === 'main' ? ' active' : '')} onClick={() => this.open('main')}>
                                <span className='imd-icon imd-icon-home' />
                                {TranslationService.trans(this.props.language, 'menu.home')}
                            </li>
                            <li className={'imd-text-contrast' + (this.props.view === 'note' ? ' active' : '')} onClick={() => this.open('note')}>
                                <span className='imd-icon imd-icon-edit-pencil' />
                                {TranslationService.trans(this.props.language, 'menu.note')}
                            </li>
                            <li className={'imd-text-contrast' + (this.props.view === 'calendars' ? ' active' : '')} onClick={() => this.open('calendars')}>
                                <span className='imd-icon imd-icon-calendar' />
                                {TranslationService.trans(this.props.language, 'menu.calendars')}
                            </li>
                            <li className={'imd-text-contrast' + (this.props.view === 'auto' ? ' active' : '')} onClick={() => this.open('auto')} style={{display: (config.env === 'prod' ? 'none' : 'block')}}>
                                <span className='imd-icon imd-icon-car' />
                                Tryb samochodowy
                            </li>
                            {
                                this.props.services.indexOf('nyumba') >= 0 ?
                                    <li className={'imd-text-contrast' + (this.props.view === 'nyumba' ? ' active' : '')} onClick={() => this.open('nyumba')}>
                                        <span className='icymat nyumba-outline' />
                                        Nyumba
                                    </li> :
                                    ''
                            }
                            {
                                this.props.user !== null && this.props.user.subscription !== 'standard' ?
                                    <li className={'imd-text-contrast' + (this.props.view === 'finance' ? ' active' : '')} onClick={() => this.open('finance')}>
                                        <span className='imd-icon imd-icon-credit-card' style={{fontSize: '11pt'}}/>
                                        {TranslationService.trans(this.props.language, 'menu.finance')}
                                    </li> :
                                    ''
                            }
                            <li className={'imd-text-contrast' + (this.props.view === 'recipes' ? ' active' : '')} onClick={() => this.open('recipes')}>
                                <span className='imd-icon imd-icon-cutlery' />
                                {TranslationService.trans(this.props.language, 'menu.recipes')}
                            </li>
                            {
                                this.props.user !== null && this.props.user.subscription !== 'standard' ?
                                    <li className={'imd-text-contrast' + (this.props.view === 'integrations' ? ' active' : '')} onClick={() => this.open('integrations')}>
                                        <span className='imd-icon imd-icon-share-android-solid' style={{fontSize: '11pt'}}/>
                                        {TranslationService.trans(this.props.language, 'menu.integrations')}
                                    </li> :
                                    ''
                            }
                            {
                                this.props.user !== null && this.props.user.domain !== null ?
                                    <li className={'imd-text-contrast' + (this.props.view === 'press-center' ? ' active' : '')} onClick={() => this.open('press-center')}>
                                        <span className='imd-icon imd-icon-podcast' style={{fontSize: '11pt'}}/>
                                        {TranslationService.trans(this.props.language, 'menu.press_center')}
                                    </li> :
                                    ''
                            }
                            {
                                this.props.flags?.mkolasa_private ?
                                    <li className={'imd-text-contrast' + (this.props.view === 'knowledge-base' ? ' active' : '')} onClick={() => this.open('knowledge-base')}>
                                        <span className='imd-icon imd-icon-database-script' style={{fontSize: '11pt'}}/>
                                        Baza wiedzy
                                    </li> :
                                    ''
                            }
                            <li className={'imd-text-contrast' + (this.props.view === 'settings' ? ' active' : '')} onClick={() => this.open('settings')}>
                                <span className='imd-icon imd-icon-settings' />
                                {TranslationService.trans(this.props.language, 'menu.settings')}
                            </li>
                        </ul>

                        <hr style={{margin: '13px 0'}} />

                        <div style={{display: 'flex', margin: '13px 3px'}}>
                            <div className="circle clipboard" onClick={() => this.setState({clipboard: true, menu: false, notifications: false})}>
                                <div className={"imd-bg-gray imd-text-50-gray"}>
                                    <span className={'imd-icon imd-icon-paste-clipboard'} />
                                </div>
                            </div>

                            <div className="circle imid">
                                <div
                                    className={"imd-bg-gray imd-text-50-gray"}
                                    title={TranslationService.trans(this.props.language, 'menu.imid.authorization')}
                                    onClick={() => this.authorizeIMid()}
                                >
                                    <span className='icymat imid' />
                                    <span className='imd-icon imd-icon-key-back' />
                                </div>
                            </div>
                            <LanguageComponent />
                        </div>
                    </div>

                    <div className="imd-sidebar-canvas imd-bg-transparent-black" onClick={() => this.setState({menu: 'imd-closed'})} />
                </div>

                <div className={'imd-sidebar menu ' + this.state.notifications}>
                    <div className={"imd-sidebar-content imd-bg-blur-real-black"}>
                        <div style={{paddingTop: '50px'}}>
                            {
                                notificationsCounter === 0 ?
                                    <span className={"imd-text-accent"}>{TranslationService.trans(this.props.language, 'menu.notifications.empty')}</span> :
                                    null
                            }

                            {
                                Object.keys(this.props.notifications.new).map(x => {
                                    return (
                                        <div className="imd-notification imd-bg-80-main imd-text-140-main" key={"n" + x}>
                                            <button
                                                type="button"
                                                className="imd-notification-close imd-text-default"
                                                onClick={() => this.setNotificationAsRead(this.props.notifications.new[x].id)}
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                            {this.props.notifications.new[x].message}
                                        </div>
                                    )
                                })
                            }

                            {
                                Object.keys(this.props.notifications.unread).map(x => {
                                    return (
                                        <div className="imd-notification imd-bg-80-silver imd-text-gray" key={"nu" + x}>
                                            <button
                                                type="button"
                                                className="imd-notification-close imd-text-default"
                                                onClick={() => this.setNotificationAsRead(this.props.notifications.unread[x].id)}
                                            >
                                                <span aria-hidden="true">×</span>
                                            </button>
                                            {this.props.notifications.unread[x].message}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                    <div className="imd-sidebar-canvas imd-bg-transparent-black" onClick={() => this.setState({notifications: 'imd-closed'})} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user),
        email: (state.user === null ? null : state.user.email),
        view: state.view,
        services: (state.user === null ? [] : state.user.imid),
        flags: state.user?.flags
    }
};

export const MainPanelContainer = connect(mapStateToProps, { setView, alert })(MainPanel);
